import { Component, Input, OnInit } from '@angular/core';
import { NgxQrcodeElementTypes, NgxQrcodeErrorCorrectionLevels } from '@techiediaries/ngx-qrcode';

@Component({
  selector: 'app-qr-verifactu',
  templateUrl: './qr-verifactu.component.html',
  styleUrls: ['./qr-verifactu.component.css']
})

// En factura Penas está el ejemplo para llamar a este componente.

export class QrVerifactuComponent implements OnInit {

    @Input() cif:string  = '';
    @Input() numeroSerie:string = '';
    @Input() fecha:string | null = '';
    @Input() importe:number = 0;


    //QR

   public elementType = NgxQrcodeElementTypes.URL;
   public correctionLevel = NgxQrcodeErrorCorrectionLevels.HIGH;
   public value = '';

  constructor(
  ) { }

  ngOnInit(): void {
   // Producción.
   this.value = `https://www2.agenciatributaria.gob.es/wlpl/TIKE-CONT/ValidarQR?nif=${this.cif}&numserie=${this.numeroSerie}&fecha=${this.fecha}&importe=${this.importe}`;
   // Desarrollo
   // this.value = `https://prewww2.aeat.es/wlpl/TIKE-CONT/ValidarQR?nif=${this.cif}&numserie=${this.numeroSerie}&fecha=${this.fecha}&importe=${this.importe}`;
   // this.generarURLQR();
  }

//   generarURLQR(): void {
   
//    const baseURL = 'https://prewww2.aeat.es/wlpl/TIKE-CONT/ValidarQR';
//    const urlParams = new URLSearchParams({
//      nif: this.cif,
//      numserie: this.numeroSerie,
//      fecha: this.misFuncionesService.formatoEspana(this.fecha),
//      importe: this.misFuncionesService.round(this.importe, 2).toString()
//    });

//    this.value = `${baseURL}?${urlParams.toString()}`;

//  }
}
